module.exports = __webpack_public_path__ + "img/profile-layout-header.addbcf19.jpg";